export const searchpubsbodegas = async () => {
    filtersPubs();
    cards();
}

const filtersPubs = () => {
    let localidad = document.querySelector('.filterLocalidad') as HTMLElement;
    if(localidad){
        localidad.addEventListener('click', function(e){
            localidad.classList.toggle('activeFilter');
        })
    }

    let experiencias = document.querySelector('.filterExperiencias') as HTMLElement;
    if(experiencias){
        experiencias.addEventListener('click', function(e){
            experiencias.classList.toggle('activeFilter');
        })
    }
}

const cards = () => {
    let cards = document.querySelectorAll('.container-results--pubs .btn-expand') as any;
    cards.forEach((element:any) => {
        element.addEventListener('click', function(e: any){
            let container = element.closest(".container-results--pubs");
            container.classList.toggle('pubs-short');
        })
    });
}